import { BodyText, Button, Checkbox, toast } from "@/components/ui";
import { useGrantRxHistoryConsent } from "@/features/Patient/MedicalRecords/RxHistory/network/useGrantRxHistoryConsent";
import { useState } from "react";

interface RxHistoryConsentFooterProps {
  patientId: string;
  consentGranted: boolean;
  onConsentGranted: () => void;
}

const CONSENT_CHECKBOX_ID = "rx-history-consent-checkbox";

export const RxHistoryConsentFooter = ({
  patientId,
  consentGranted,
  onConsentGranted,
}: RxHistoryConsentFooterProps) => {
  const [isChecked, setIsChecked] = useState(false);

  const { mutate: grantConsent, isPending } = useGrantRxHistoryConsent({
    patientId,
    onSuccess: () => {
      toast.success("RX history consent granted successfully");
      setIsChecked(false);
      onConsentGranted();
    },
    onError: () => {
      toast.error("Failed to grant RX history consent");
    },
  });

  if (consentGranted) {
    return (
      <div
        className="flex items-center gap-2 border-t pt-3 mt-3"
        data-testid="rx-history-consent-active"
      >
        <Checkbox checked disabled />
        <BodyText size="sm" textColor="tertiary">
          Consent granted
        </BodyText>
      </div>
    );
  }

  return (
    <div
      className="flex items-center justify-between border-t pt-3 mt-3"
      data-testid="rx-history-consent-form"
    >
      <label
        htmlFor={CONSENT_CHECKBOX_ID}
        className="flex items-center gap-2 cursor-pointer"
      >
        <Checkbox
          id={CONSENT_CHECKBOX_ID}
          checked={isChecked}
          onCheckedChange={(checked) => setIsChecked(checked === true)}
          disabled={isPending}
          data-testid="rx-history-consent-checkbox"
        />
        <BodyText size="sm">
          Patient consents to medication history retrieval
        </BodyText>
      </label>
      <Button
        size="sm"
        disabled={!isChecked || isPending}
        isLoading={isPending}
        onClick={() => grantConsent()}
        data-testid="rx-history-grant-consent-button"
      >
        Grant Consent
      </Button>
    </div>
  );
};
